// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const CustomSolutionsSignetIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon
      data-iconname="CustomSolutionsSignetIcon"
      ref={forwardedRef}
      {...props}
    >
      <path d="M9.502 15.78C9.472 15.846 9.384 16 9.206 16H5.642l-.047-.002c-.39 0-.63-.329-.714-.47l-2.24-4.985a1.8 1.8 0 0 1-.006-1.255L2.638 9.28l2.07-4.606 2.545 5.662.193.428 1.184 2.632H8.628l.875 1.943a.54.54 0 0 1 0 .44" />
      <path d="m17.365 10.726-.003.006-2.07 4.606-2.545-5.662-.194-.428-2.056-4.575a.54.54 0 0 1 0-.44c.03-.066.118-.22.297-.22h3.569l.042.001c.389 0 .63.33.714.47l2.24 4.986a1.8 1.8 0 0 1 .005 1.255" />
      <path d="M8.4 4.013H5.526L7.6 8.622l1.436-3.195C9.318 4.799 8.966 4.013 8.4 4.013" />
      <path d="M11.59 15.999h2.873l-2.071-4.609-1.437 3.195C10.673 15.213 11.025 16 11.591 16" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const CustomSolutionsSignetIcon = /* @__PURE__ */ Object.assign(
  CustomSolutionsSignetIconComponent,
  { displayName: 'CustomSolutionsSignetIcon' },
);
